import React, { useMemo } from "react";
import { Grid, Typography } from "@material-ui/core";
import intl from "react-intl-universal";

import { IWithballData } from "types";
import { StatisticsBoard } from "components/StatisticsBoard";

import { calculatePecentage, groupWithBallByPosition } from "utils";

interface IMyDefensePanelProps {
  tackleDataArray: IWithballData[];
  interceptionDataArray: IWithballData[];
  clearanceDataArray: IWithballData[];
}

export const MyDefensePanel = ({
  tackleDataArray,
  interceptionDataArray,
  clearanceDataArray,
}: IMyDefensePanelProps) => {
  const { tackleSummary, interceptionSummary } = useMemo(() => {
    return {
      tackleSummary: groupWithBallByPosition(tackleDataArray),
      interceptionSummary: groupWithBallByPosition(interceptionDataArray),
    };
  }, [tackleDataArray, interceptionDataArray]);
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="h4">{`${intl.get("STATS_LABEL_TACKLE")}: ${
            tackleDataArray.length
          }`}</Typography>
          <Typography>{`${intl.get("STATS_POS_SELF")}: ${
            tackleSummary.selfHalf.length
          } (${calculatePecentage(
            tackleSummary.selfHalf.length,
            tackleDataArray.length
          )})`}</Typography>
          <Typography>{`${intl.get("STATS_POS_OTHER")}: ${
            tackleSummary.otherHalf.length
          } (${calculatePecentage(
            tackleSummary.otherHalf.length,
            tackleDataArray.length
          )})`}</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <StatisticsBoard data={tackleDataArray} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h4">{`${intl.get("STATS_LABEL_INTERCEPTION")}: ${
            interceptionDataArray.length
          }`}</Typography>
          <Typography>{`${intl.get("STATS_POS_SELF")}: ${
            interceptionSummary.selfHalf.length
          } (${calculatePecentage(
            interceptionSummary.selfHalf.length,
            interceptionDataArray.length
          )})`}</Typography>
          <Typography>{`${intl.get("STATS_POS_OTHER")}: ${
            interceptionSummary.otherHalf.length
          } (${calculatePecentage(
            interceptionSummary.otherHalf.length,
            interceptionDataArray.length
          )})`}</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <StatisticsBoard data={interceptionDataArray} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h4">{`${intl.get("STATS_LABEL_CLEAR")}: ${
            clearanceDataArray.length
          }`}</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <StatisticsBoard data={clearanceDataArray} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
